<template>
  <el-row :gutter="10">
    <el-col :xs="24" :sm="10" class="mb-10px">
      <rapid-test-statistic/>
    </el-col>
    <el-col :xs="24" :sm="14">
      <rapid-test-detail/>
    </el-col>
  </el-row>
</template>

<script>
import RapidTestStatistic from "./RapidTestStatistic.vue";
import RapidTestDetail from "./RapidTestDetail.vue";
import {setNavTitle} from "@/views/useNavTitle";

export default {
  name: "RapidTest",
  components: {
    'rapid-test-statistic': RapidTestStatistic,
    'rapid-test-detail': RapidTestDetail,
  },
  mounted() {
    setNavTitle("篩檢")
  }
};
</script>

<style scoped>

</style>
